import {
    CREATESALESPARTYTYPE,
    GETSALESPARTYTYPE,
    UPDATESALESPARTYTYPE,
    DELETESALESPARTYTYPE,
  } from "../actions/types";
  
  const initialState = {
    salesPartyTypeList: [],
    createSalesPartyType: null,
    updateSalesPartyType: null,
    deleteSalesPartyType: null,
  };
  
  export default function (state = initialState, action) {
    switch (action.type) {
  
      case GETSALESPARTYTYPE:
        return {
          ...state,
          salesPartyTypeList: action.payload.data,
        };
  
      case CREATESALESPARTYTYPE:
        return {
          ...state,
          createSalesPartyType: action.payload,
        };
  
      case UPDATESALESPARTYTYPE:
        return {
          ...state,
          updateSalesPartyType: action.payload,
        };
  
      case DELETESALESPARTYTYPE:
        return {
          ...state,
          deleteSalesPartyType: action.payload,
        };
  
      default:
        return state;
    }
  }
  